import * as mixpanel from '../../../../../../../mixpanel';

export default (filterType, decisionFrameworkType) => {
  mixpanel.actions.trackEvent(mixpanel.events.CLIENT_SET_LOVERS_HATERS_FILTER, {
    [mixpanel.eventProperties.FILTER_TYPE]: filterType,
    [mixpanel.eventProperties.DECISION_FRAMEWORK_TYPE]: decisionFrameworkType
  });
};
